module.exports = {"230224100":"泰来镇","230224101":"平洋镇","230224102":"汤池镇","230224103":"江桥蒙古族镇","230224104":"塔子城镇","230224105":"大兴镇","230224106":"和平镇","230224107":"克利镇","230224200":"胜利蒙古族乡","230224209":"宁姜蒙古族乡","230224400":"葡萄场","230224401":"果树场","230224402":"泰来县一苗圃","230224403":"泰来县二苗圃","230224404":"东方红机械林场","230224480":"六三监狱","230224500":"泰来农场","230224580":"第一良种场","230224581":"第二良种场","230224582":"宏胜种畜场","230224583":"二龙涛农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230224.json
// module id = 642
// module chunks = 0